import { ChevronDownIcon } from '@chakra-ui/icons'
import { Button, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react'
import useDownloadCounted from 'hooks/useDownload/useDownloadCounted'

const DownloadCountingButton = (props) => {
    const { countingId, counting, group_items } = props
    const { downloadCounted, downloadFormats, isLoading } = useDownloadCounted(countingId, counting, group_items)

    return (
        <Menu>
            <MenuButton
                as={Button}
                size='sm'
                colorScheme='teal'
                mr='1'
                isLoading={isLoading}
                loadingText='Generating...'
                rightIcon={<ChevronDownIcon />}
            >
                Download
            </MenuButton>
            <MenuList>
                {downloadFormats.map((format) => (
                    <MenuItem
                        key={format.value}
                        onClick={() => downloadCounted(format.value)}
                        isDisabled={isLoading}
                    >
                        {format.label}
                    </MenuItem>
                ))}
            </MenuList>
        </Menu>
    )
}

export default DownloadCountingButton
